import React, { FC, ChangeEvent, FocusEvent } from 'react'
import classnames from 'classnames'
import { PHONE_CALL_CODE_MIN_LENGTH, PHONE_SMS_CODE_MIN_LENGTH } from '../../../../validator/constants'
import { Input } from '../../../Input2/Input'
import style from './PhoneCodeInput.module.css'

const validateCode = (value: string, isCallCode: boolean): boolean =>
  new RegExp(`^[0-9]{0,${isCallCode ? PHONE_CALL_CODE_MIN_LENGTH : PHONE_SMS_CODE_MIN_LENGTH}}$`, 'i').test(value)

type PhoneCodeInputProps = {
  className?: string
  name?: string
  value?: string
  placeholder?: string
  disabled?: boolean
  isError?: boolean
  isCallCode: boolean
  onChange?(e: ChangeEvent<HTMLInputElement>): void
  onFocus?(data: FocusEvent<HTMLInputElement, Element>): void
  onBlur?(e: FocusEvent<HTMLInputElement, Element>): void
}

export const PhoneCodeInput: FC<PhoneCodeInputProps> = ({
  onChange,
  onFocus,
  onBlur,
  className,
  isCallCode,
  disabled = false,
  name,
  value,
  placeholder,
  isError = false,
}) => {
  const classNames = classnames(style.phoneCodeInput, className)

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>): void => {
    if (onChange && validateCode(e.target.value, isCallCode)) {
      onChange(e)
    }
  }

  return (
    <Input
      name={name}
      value={value}
      className={classNames}
      disabled={disabled}
      placeholder={placeholder}
      isError={isError}
      onChange={onChangeHandler}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
}

PhoneCodeInput.displayName = 'PhoneCodeInput'
